<template>
    <div class="w-full flex flex-row px-3 py-2 cursor-pointer border-100 border-bottom-1" @click="popup=true" style="min-height:50px">
        <div class="flex mr-3 align-items-center">
            <Avatar class="text-600" size="small" icon="pi pi-user" shape="circle"/>
        </div>
        <div class="flex flex-1 justify-content-left align-items-center">
            <span class="text-600">{{ name }}</span>
        </div>
        <div class="flex justify-content-right align-items-center">
            <span v-if="!name" class="text-sm text-blue-500">{{ lang('button_set') }}</span>
            <i class="text-blue-500 ml-2" :class="'pi pi-angle-right'" />
        </div>
    </div>
    
    <Dialog class="w-full surface-100 border-none" modal
        v-model:visible="popup" @hide="setUpDefault"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: 'auto!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: 'auto' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ lang('fullname_link_title') }}</span>
        </template>

        <div class="w-full flex flex-column gap-2">
            <span class="flex text-sm text-600">{{ lang('name')}}:</span>
            <IconField iconPosition="right">
                <InputIcon class="pi pi-user surface-0 pl-1"/>
                <InputText id="name" v-model="v$.name.$model" 
                    :class="{'p-invalid':v$.name.$invalid}" size="large"
                    class='w-full border-2 border-round-xl'/>
                <InputIcon class="pi pi-times surface-0 pr-1 cursor-pointer" @click="clear"/>
            </IconField>
            <div class="w-full h-2rem">
                <small v-if="(v$.name.$invalid) || v$.name.$pending.$response" class="text-red-500">
                    {{ content[lang_].invalid }}
                </small>
            </div>
        </div>

        <template #footer>
            <div class="w-full flex flex-row gap-3">
                <Button type="submit" class="w-full border-round-lg" @click="updateUser()"
                    :label="lang('button_save')" :loading="loading" :disabled="!isValid || loading" size="large"/>
            </div>
        </template>
    </Dialog>
</template>

<script>
import { mapActions } from      "vuex"
import { useVuelidate } from    "@vuelidate/core"
import MobMenu from             '@/components/sides/menu/MobMenu.vue' 
import { email, required, sameAs, minLength, maxLength } from "@vuelidate/validators";

export default {
    data(){
        return {
            loading: false,
            name: null,
            popup: false,
            v$: useVuelidate(),
            content: {
                ru: {
                    invalid: 'Имя должно содержать от 3 до 30 символов',
                },
                en: {
                    invalid: 'Name must be between 3 and 30 characters',
                }
            }
        }
    },
    validations() {
        return {
            name: {
                required,
                minimunLength: minLength(3),
                maxLength: maxLength(30),
            },
        }
    },
    components: {
        MobMenu
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        screenSize() { return this.$store.getters.StateScreenSize },
        isValid: function () {
            return this.v$.name.$pending === false && this.v$.name.$invalid === false
        }
    },
    methods:{
        lang(value){
            return this.$t(`views.personal.profile.${value}`)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        setUpDefault(){
            this.name = (this.$store.getters.StateUserName) ? this.$store.getters.StateUserName : null
        },
        clear(){
            this.name = null
        },
        ...mapActions(["ActionUpdUser"]),
        async updateUser() {
            this.loading = true

            let updData = {
                name: this.name,
            }

            try{
                const update = await this.ActionUpdUser(updData).then(res=>res)
                if(update.result && update.data) {
                    this.showMess('success', this.lang('mess_success'), this.lang('mess_success_text'))
                    this.loading = false
                    this.popup = false
                } else {
                    this.loading = false
                    if(update.errors) this.showMess('error', this.lang('mess_error'), update.errors[0])
                    else this.showMess('error', this.lang('mess_error'), this.lang('mess_error_text'))
                }
            } catch (e) {
                console.log(e)
                this.loading = false
                this.showMess('error', 'Error', 'Profile editing error')
            }
        },
    },
    created() {
        this.setUpDefault()
        this.v$ = useVuelidate()
    },
}
</script>